import React, { useState } from "react";
import InputMask from 'react-input-mask';
import Button from "../../../components/Button";
import ModalContent from "../../../components/ModalContent";
import ModalButtons from "../../../components/ModalButtons";
import ToastMessage from "../../../components/ToastMessage";
import {validateField} from "../../../utils/validateField";
import { useNewContact } from "../../../context/contextNewContact";
import { useColorMode } from "../../../context/contextColorMode";

import { FormContact } from "../styles";

const Cpf = ({ navigation }) => {
  const [error, setError] = useState(false);
  const {isEnabled} = useColorMode();
  const { cpf, setCpf, setSector } = useNewContact();

  const { next, previous } = navigation;

  return (
    <>
      {error ? (
        <ToastMessage
          variant="info"
          message="Preencha este campo antes de continuar!"
        />
      ) : null}
      <ModalContent displayFlex={true}>
        <FormContact darkMode={isEnabled}>
          <h2>INFORME O CPF DO CONTATO</h2>
          <InputMask
            mask="999.999.999-99"
            maskChar={null}
            value={cpf}
            placeholder="000.000.000-00"
            onChange={(e) => setCpf(e.target.value)}
          />
        </FormContact>
      </ModalContent>
      <ModalButtons>
        <Button
          bgcolor="var(--blue)"
          color="#fff"
          border="var(--blue)"
          hover="var(--blue-hover)"
          expansive={true}
          hollow={false}
          size="small"
          onClick={async () => {
            await validateField(cpf, 'text', next, setError);
            setError(false);
          }}
        >
          CONTINUAR
        </Button>
        <hr />
        <Button
          color="var(--gray)"
          border="var(--gray)"
          expansive={true}
          hollow={true}
          size="small"
          onClick={() => {
            setSector([]);
            previous();
          }}
        >
          VOLTAR
        </Button>
      </ModalButtons>
    </>
  );
};

export default Cpf;
